import React, { useState } from 'react';
import './BookDemo.css';

const SOURCE_OPTIONS = [
  'Friend / Family Referral',
  'School / College Recommendation',
  'Google Search',
  'Social Media (Instagram / Facebook)',
  'YouTube',
  'LinkedIn',
  'WhatsApp',
  'Newspaper / Magazine',
  'Event / Hackathon',
  'ibots Website',
  'Other',
];

const errStyle = { color: '#e8394d', fontSize: '11px', marginTop: '4px' };

function BookDemo({ onClose }) {
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    fullName: '', phone: '', email: '', city: '',
    iAmA: '', grade: '', schoolName: '', department: '',
    childGrade: '', childSchool: '', childProgramme: '',
    teacherSchool: '', teacherSubject: '',
    institutionName: '', contactRole: '', studentCount: '',
    otherRole: '', programme: '', subInterest: '',
    collegeProgramme: '', interest: '',
    source: '', customSource: '',
  });

  const handleChange = (e) => {
    const updated = { ...formData, [e.target.name]: e.target.value };
    if (e.target.name === 'iAmA') {
      updated.programme = '';
      updated.subInterest = '';
      updated.collegeProgramme = '';
    }
    if (e.target.name === 'programme') updated.subInterest = '';
    setFormData(updated);
    setErrors({ ...errors, [e.target.name]: '' });
  };

 const handleSubmit = async () => {
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = 'Full name is required';
    if (!formData.phone) newErrors.phone = 'Phone number is required';
    if (!formData.iAmA) newErrors.iAmA = 'Please select who you are';
    if (!formData.source) newErrors.source = 'Please tell us how you heard about ibots';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setTimeout(() => {
        const firstError = document.querySelector('.error-field');
        if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
      return;
    }

    try {
      await fetch('http://localhost:5000/api/enquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          formType: 'book-demo',
          fullName: formData.fullName,
          phone: formData.phone,
          email: formData.email,
          city: formData.city,
          iAmA: formData.iAmA,
          grade: formData.grade,
          institution: formData.schoolName || formData.institutionName,
          department: formData.department,
          childGrade: formData.childGrade,
          childSchool: formData.childSchool,
          contactRole: formData.contactRole,
          studentCount: formData.studentCount,
          programme: formData.programme,
          subInterest: formData.subInterest,
          interest: formData.interest,
          source: formData.source === 'Other' ? formData.customSource : formData.source,
        }),
      });
    } catch (err) {
      console.log('Your backend error:', err);
    }

    try {
      await fetch('http://localhost:5000/api/demo', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name:         formData.fullName,
          type:         formData.iAmA === 'college-student' || formData.iAmA === 'college'
                          ? 'College'
                          : formData.iAmA === 'other'
                          ? 'Other'
                          : 'School',
          phone:        formData.phone,
          email:        formData.email,
          city:         formData.city,
          institution:  formData.schoolName || formData.institutionName || formData.childSchool || '',
          grade:        formData.grade || formData.childGrade || '',
          course:       formData.subInterest || formData.programme || '',
          department:   formData.department || '',
          contactRole:  formData.contactRole || '',
          studentCount: formData.studentCount || '',
          interest:     formData.interest || '',
          source:       formData.source === 'Other' ? formData.customSource : formData.source,
          formType:     'book-demo',
        }),
      });
    } catch (err) {
      console.log('Training dashboard error:', err);
    }

    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="modal__overlay" onClick={onClose}>
        <div className="modal__box" onClick={(e) => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center', gap: '16px' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#dcfce7', color: '#16a34a', fontSize: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900 }}>✓</div>
          <h2 style={{ color: '#0d2e6e', fontWeight: 900, margin: 0 }}>Thank You for Reaching Out to ibots!</h2>
          <p style={{ color: '#64748b', margin: 0, maxWidth: '300px', lineHeight: '1.6' }}>We have received your demo request. Our team will get in touch with you within <strong>24 hours</strong> to schedule your free demo session.</p>
          <button className="form__submit" onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }

  return (
    <div className="modal__overlay" onClick={onClose}>
      <div className="modal__box" onClick={(e) => e.stopPropagation()}>

        <button className="modal__close" onClick={onClose}>✕</button>
        <h2 className="modal__title">Book a Demo Session</h2>
        <p className="modal__subtitle">
          Tell us about yourself and we'll schedule a free demo session
          at your nearest ibots centre or online.
        </p>

        <div className="modal__form">

          <div className="form__row">
            <div className="form__group">
              <label className="form__label">Full Name *</label>
              <input type="text" name="fullName" value={formData.fullName}
                onChange={handleChange} placeholder="Enter your full name" className="form__input" />
              {errors.fullName && <p style={errStyle} className="error-field">{errors.fullName}</p>}
            </div>
            <div className="form__group">
              <label className="form__label">Phone Number *</label>
              <input type="text" name="phone" value={formData.phone}
                onChange={handleChange} placeholder="+91 XXXXX XXXXX" className="form__input" />
              {errors.phone && <p style={errStyle}>{errors.phone}</p>}
            </div>
          </div>

          <div className="form__row">
            <div className="form__group">
              <label className="form__label">Email Address</label>
              <input type="email" name="email" value={formData.email}
                onChange={handleChange} placeholder="you@example.com" className="form__input" />
            </div>
            <div className="form__group">
              <label className="form__label">City / Location</label>
              <input type="text" name="city" value={formData.city}
                onChange={handleChange} placeholder="e.g. Coimbatore" className="form__input" />
            </div>
          </div>

          <div className="form__group form__group--full">
            <label className="form__label">I Am A *</label>
            <select name="iAmA" value={formData.iAmA}
              onChange={handleChange} className="form__input form__select">
              <option value="">Select...</option>
              <option value="school-student">School Student</option>
              <option value="college-student">College Student</option>
              <option value="parent">Parent</option>
              <option value="school">School / Institution Representative</option>
              <option value="college">College / University Representative</option>
              <option value="other">Other</option>
            </select>
            {errors.iAmA && <p style={errStyle} className="error-field">{errors.iAmA}</p>}
          </div>

          {formData.iAmA === 'school-student' && (
            <>
              <div className="form__row">
                <div className="form__group">
                  <label className="form__label">Grade / Standard *</label>
                  <select name="grade" value={formData.grade}
                    onChange={handleChange} className="form__input form__select">
                    <option value="">Select grade...</option>
                    {['Grade 3','Grade 4','Grade 5','Grade 6','Grade 7',
                      'Grade 8','Grade 9','Grade 10','Grade 11','Grade 12'].map((g,i) => (
                      <option key={i} value={g.toLowerCase().replace(' ','')}>{g}</option>
                    ))}
                  </select>
                </div>
                <div className="form__group">
                  <label className="form__label">School Name</label>
                  <input type="text" name="schoolName" value={formData.schoolName}
                    onChange={handleChange} placeholder="Enter your school name" className="form__input" />
                </div>
              </div>
              <div className="form__group form__group--full">
                <label className="form__label">Which Programme Are You Interested In? *</label>
                <select name="programme" value={formData.programme}
                  onChange={handleChange} className="form__input form__select">
                  <option value="">Select programme...</option>
                  <option value="innovators">Innovators Programme (12-Month Online)</option>
                  <option value="regular">Hands on Training Program (Weekend Regular)</option>
                  <option value="intensive">Daily Session Training (Holiday Intensive)</option>
                  <option value="camp">Hands on Training Camp (Seasonal Camp)</option>
                </select>
              </div>
              {formData.programme === 'innovators' && (
                <div className="form__group form__group--full">
                  <label className="form__label">Preferred Phase to Start</label>
                  <select name="subInterest" value={formData.subInterest}
                    onChange={handleChange} className="form__input form__select">
                    <option value="">Select...</option>
                    <option value="phase1">Phase 1 — Electrical Basics</option>
                    <option value="phase2">Phase 2 — IoT & Smart Systems</option>
                    <option value="phase3">Phase 3 — Robotics & Drones</option>
                    <option value="full">Full 12-Month Journey</option>
                  </select>
                </div>
              )}
              {formData.programme === 'regular' && (
                <div className="form__group form__group--full">
                  <label className="form__label">Which Course Are You Interested In?</label>
                  <select name="subInterest" value={formData.subInterest}
                    onChange={handleChange} className="form__input form__select">
                    <option value="">Select course...</option>
                    <option value="electronics">Electronics</option>
                    <option value="embedded">Embedded Systems</option>
                    <option value="iot">IoT</option>
                    <option value="robotics">Robotics</option>
                    <option value="drone">Drone Technology</option>
                    <option value="ai-tinyml">AI & Tiny ML</option>
                    <option value="3d">3D Design & Printing</option>
                    <option value="mechatronics">Mechatronics</option>
                    <option value="ai-rpi">Artificial Intelligence with Raspberry Pi</option>
                    <option value="little1">Little Innovator 1 (Age 6-7)</option>
                    <option value="little2">Little Innovator 2 (Age 6-7)</option>
                    <option value="custom">Customised Learning Path</option>
                    <option value="not-sure">Not Sure Yet</option>
                  </select>
                </div>
              )}
              {formData.programme === 'intensive' && (
                <div className="form__group form__group--full">
                  <label className="form__label">Which Course Are You Interested In?</label>
                  <select name="subInterest" value={formData.subInterest}
                    onChange={handleChange} className="form__input form__select">
                    <option value="">Select course...</option>
                    <option value="electronics">Electronics</option>
                    <option value="embedded">Embedded Systems</option>
                    <option value="iot">IoT</option>
                    <option value="robotics">Robotics</option>
                    <option value="drone">Drone Technology</option>
                    <option value="ai-tinyml">AI & Tiny ML</option>
                    <option value="3d">3D Design & Printing</option>
                    <option value="mechatronics">Mechatronics</option>
                    <option value="not-sure">Not Sure Yet</option>
                  </select>
                </div>
              )}
              {formData.programme === 'camp' && (
                <div className="form__group form__group--full">
                  <label className="form__label">Which Course Are You Interested In?</label>
                  <select name="subInterest" value={formData.subInterest}
                    onChange={handleChange} className="form__input form__select">
                    <option value="">Select course...</option>
                    <option value="electronics">Electronics</option>
                    <option value="embedded">Embedded Systems</option>
                    <option value="iot">IoT</option>
                    <option value="robotics">Robotics</option>
                    <option value="drone">Drone Technology</option>
                    <option value="not-sure">Not Sure Yet</option>
                  </select>
                </div>
              )}
            </>
          )}

          {formData.iAmA === 'college-student' && (
            <>
              <div className="form__row">
                <div className="form__group">
                  <label className="form__label">Year of Study *</label>
                  <select name="grade" value={formData.grade}
                    onChange={handleChange} className="form__input form__select">
                    <option value="">Select year...</option>
                    <option value="year1">1st Year</option>
                    <option value="year2">2nd Year</option>
                    <option value="year3">3rd Year</option>
                    <option value="year4">4th Year</option>
                    <option value="pg1">PG - 1st Year</option>
                    <option value="pg2">PG - 2nd Year</option>
                  </select>
                </div>
                <div className="form__group">
                  <label className="form__label">Department *</label>
                  <input type="text" name="department" value={formData.department}
                    onChange={handleChange} placeholder="e.g. ECE, CSE, Mechanical..."
                    className="form__input" />
                </div>
              </div>
              <div className="form__group form__group--full">
                <label className="form__label">College Name</label>
                <input type="text" name="schoolName" value={formData.schoolName}
                  onChange={handleChange} placeholder="Enter your college name" className="form__input" />
              </div>
              <div className="form__group form__group--full">
                <label className="form__label">Which Programme Are You Interested In? *</label>
                <select name="programme" value={formData.programme}
                  onChange={handleChange} className="form__input form__select">
                  <option value="">Select programme...</option>
                  <option value="regular">Hands on Training (Regular Weekend)</option>
                  <option value="specialised">Specialised Course (Custom)</option>
                </select>
              </div>
              {formData.programme === 'regular' && (
                <div className="form__group form__group--full">
                  <label className="form__label">Which Course Are You Interested In?</label>
                  <select name="subInterest" value={formData.subInterest}
                    onChange={handleChange} className="form__input form__select">
                    <option value="">Select course...</option>
                    <option value="electronics">Electronics</option>
                    <option value="embedded">Embedded Systems</option>
                    <option value="iot">IoT</option>
                    <option value="robotics">Robotics</option>
                    <option value="drone">Drone Technology</option>
                    <option value="ai-tinyml">AI & Tiny ML</option>
                    <option value="3d">3D Design & Printing</option>
                    <option value="mechatronics">Mechatronics</option>
                    <option value="stm32">STM32 Microcontroller</option>
                    <option value="ai">AI (Artificial Intelligence)</option>
                    <option value="ros">ROS / ROS2</option>
                    <option value="not-sure">Not Sure Yet</option>
                  </select>
                </div>
              )}
              {formData.programme === 'specialised' && (
                <div className="form__group form__group--full">
                  <label className="form__label">Primary Technology Interest</label>
                  <select name="subInterest" value={formData.subInterest}
                    onChange={handleChange} className="form__input form__select">
                    <option value="">Select area...</option>
                    <option value="ai-vision">AI with Raspberry Pi (Computer Vision)</option>
                    <option value="drone">Drone Technology (Advanced)</option>
                    <option value="iiot">Industrial IoT (IIoT)</option>
                    <option value="mechatronics">Mechatronics & Robotics</option>
                    <option value="stm32">STM32 & ARM Development</option>
                    <option value="ai-embedded">AI + Embedded Systems</option>
                    <option value="custom">Custom Combination</option>
                  </select>
                </div>
              )}
            </>
          )}

          {formData.iAmA === 'parent' && (
            <>
              <div className="form__row">
                <div className="form__group">
                  <label className="form__label">Child's Grade / Standard *</label>
                  <select name="childGrade" value={formData.childGrade}
                    onChange={handleChange} className="form__input form__select">
                    <option value="">Select grade...</option>
                    {['Grade 1','Grade 2','Grade 3','Grade 4','Grade 5','Grade 6',
                      'Grade 7','Grade 8','Grade 9','Grade 10','Grade 11','Grade 12'].map((g,i) => (
                      <option key={i} value={g.toLowerCase().replace(' ','')}>{g}</option>
                    ))}
                  </select>
                </div>
                <div className="form__group">
                  <label className="form__label">Child's School Name</label>
                  <input type="text" name="childSchool" value={formData.childSchool}
                    onChange={handleChange} placeholder="Enter school name" className="form__input" />
                </div>
              </div>
              <div className="form__group form__group--full">
                <label className="form__label">Which Programme Are You Interested In?</label>
                <select name="programme" value={formData.programme}
                  onChange={handleChange} className="form__input form__select">
                  <option value="">Select programme...</option>
                  <option value="innovators">Innovators Programme (12-Month Online)</option>
                  <option value="regular">Hands on Training Program (Weekend Regular)</option>
                  <option value="intensive">Daily Session Training (Holiday Intensive)</option>
                  <option value="camp">Hands on Training Camp (Seasonal Camp)</option>
                  <option value="not-sure">Not Sure Yet — Need Guidance</option>
                </select>
              </div>
            </>
          )}

          {formData.iAmA === 'school' && (
            <>
              <div className="form__row">
                <div className="form__group">
                  <label className="form__label">School Name *</label>
                  <input type="text" name="institutionName" value={formData.institutionName}
                    onChange={handleChange} placeholder="Enter school name" className="form__input" />
                </div>
                <div className="form__group">
                  <label className="form__label">Your Role *</label>
                  <select name="contactRole" value={formData.contactRole}
                    onChange={handleChange} className="form__input form__select">
                    <option value="">Select role...</option>
                    <option value="principal">Principal</option>
                    <option value="vice-principal">Vice Principal</option>
                    <option value="hod">Head of Department</option>
                    <option value="coordinator">Programme Coordinator</option>
                    <option value="teacher">Teacher</option>
                    <option value="admin">Admin / Management</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
              <div className="form__row">
                <div className="form__group">
                  <label className="form__label">Approximate Student Count</label>
                  <input type="text" name="studentCount" value={formData.studentCount}
                    onChange={handleChange} placeholder="e.g. 200 students" className="form__input" />
                </div>
                <div className="form__group">
                  <label className="form__label">Programme Interested In</label>
                  <select name="programme" value={formData.programme}
                    onChange={handleChange} className="form__input form__select">
                    <option value="">Select...</option>
                    <option value="short">4–5 Month Campus Programme</option>
                    <option value="full">8–9 Month Campus Programme</option>
                    <option value="not-sure">Not Sure — Need Consultation</option>
                  </select>
                </div>
              </div>
            </>
          )}

          {formData.iAmA === 'college' && (
            <>
              <div className="form__row">
                <div className="form__group">
                  <label className="form__label">College / University Name *</label>
                  <input type="text" name="institutionName" value={formData.institutionName}
                    onChange={handleChange} placeholder="Enter college name" className="form__input" />
                </div>
                <div className="form__group">
                  <label className="form__label">Your Role *</label>
                  <select name="contactRole" value={formData.contactRole}
                    onChange={handleChange} className="form__input form__select">
                    <option value="">Select role...</option>
                    <option value="hod">Head of Department</option>
                    <option value="professor">Professor / Associate Professor</option>
                    <option value="coordinator">Training Coordinator</option>
                    <option value="principal">Principal / Director</option>
                    <option value="placement">Placement Officer</option>
                    <option value="admin">Admin / Management</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
              <div className="form__row">
                <div className="form__group">
                  <label className="form__label">Department</label>
                  <input type="text" name="department" value={formData.department}
                    onChange={handleChange} placeholder="e.g. ECE, CSE, Mechanical..."
                    className="form__input" />
                </div>
                <div className="form__group">
                  <label className="form__label">Approximate Student Count</label>
                  <input type="text" name="studentCount" value={formData.studentCount}
                    onChange={handleChange} placeholder="e.g. 120 students" className="form__input" />
                </div>
              </div>
              <div className="form__group form__group--full">
                <label className="form__label">Programme Interested In</label>
                <select name="programme" value={formData.programme}
                  onChange={handleChange} className="form__input form__select">
                  <option value="">Select...</option>
                  <option value="workshop-regular">Regular Workshop (Embedded & IoT)</option>
                  <option value="workshop-advanced">Advanced Workshop (Drone, Mechatronics, AI+RPI)</option>
                  <option value="workshop-custom">Customised Workshop</option>
                  <option value="vac">Value Added Courses (Semester-long)</option>
                  <option value="event">Single Day Event / Orientation</option>
                  <option value="expert">Expert Talk / Guest Lecture</option>
                  <option value="fdp">FDP (Faculty Development Programme)</option>
                  <option value="not-sure">Not Sure — Need Consultation</option>
                </select>
              </div>
            </>
          )}

          {formData.iAmA === 'other' && (
            <div className="form__group form__group--full">
              <label className="form__label">Please describe your role</label>
              <input type="text" name="otherRole" value={formData.otherRole}
                onChange={handleChange}
                placeholder="e.g. Corporate trainer, freelancer, researcher..."
                className="form__input" />
            </div>
          )}

          <div className="form__group form__group--full">
            <label className="form__label">Any Additional Requirements or Questions?</label>
            <textarea name="interest" value={formData.interest}
              onChange={handleChange}
              placeholder="Any specific requirements, preferred dates, or questions..."
              className="form__input form__textarea" />
          </div>

          <div className="form__group form__group--full">
            <label className="form__label">How did you hear about ibots? *</label>
            <select name="source" value={formData.source}
              onChange={handleChange} className="form__input form__select">
              <option value="">Select...</option>
              {SOURCE_OPTIONS.map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
            {errors.source && <p style={errStyle} className="error-field">
              {errors.source}</p>}
            {formData.source === 'Other' && (
              <input type="text" name="customSource" value={formData.customSource}
                onChange={handleChange} placeholder="Please tell us how you found us..."
                className="form__input" style={{ marginTop: '8px' }} />
            )}
          </div>

          <button className="form__submit" onClick={handleSubmit}>
            Submit Demo Request →
          </button>

        </div>
      </div>
    </div>
  );
}

export default BookDemo;